// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import customerApi from '~/apis/customer';
import {
  CREATE_CUSTOMER,
  EDIT_CUSTOMER,
  DELETE_CUSTOMER,
  EXPORT_CUSTOMER,
  GET_CUSTOMER_DETAIL,
  GET_CUSTOMER_LIST,
  IMPORT_CUSTOMER,
  SEND_TO_QUICK_BOOKS,
} from '~/utils/constants/actionType';
import { IBaseDeleteBody, IQueryParamBase } from '~/utils/interface/common';
import { GET_SCHEDULE_LIST_BY_CUSTOMER } from '~/utils/constants/actionType';
import { IParamScheduleForCustomerDetail, IPayloadEditCustomer } from '~/utils/interface/customer';

export const getCustomerList = createAsyncThunk(
  GET_CUSTOMER_LIST,
  async (params: IQueryParamBase, { rejectWithValue }) => {
    try {
      const resp = await customerApi.getCustomerList(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const createCustomer = createAsyncThunk(
  CREATE_CUSTOMER,
  async (formData: FormData, { rejectWithValue }) => {
    try {
      const resp = await customerApi.createCustomer(formData);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const editCustomer = createAsyncThunk(
  EDIT_CUSTOMER,
  async (payload: IPayloadEditCustomer, { rejectWithValue }) => {
    try {
      const resp = await customerApi.editCustomer(payload);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getCustomerDetail = createAsyncThunk(
  GET_CUSTOMER_DETAIL,
  async (id: string, { rejectWithValue }) => {
    try {
      const resp = await customerApi.getCustomerDetail(id);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getScheduleCustomerList = createAsyncThunk(
  GET_SCHEDULE_LIST_BY_CUSTOMER,
  async (params: IParamScheduleForCustomerDetail, { rejectWithValue }) => {
    try {
      const resp = await customerApi.getScheduleList(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const importCustomer = createAsyncThunk(
  IMPORT_CUSTOMER,
  async (formData: FormData, { rejectWithValue }) => {
    try {
      const resp = await customerApi.importCustomer(formData);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const exportCustomer = createAsyncThunk(
  EXPORT_CUSTOMER,
  async (params: IQueryParamBase, { rejectWithValue }) => {
    try {
      const resp = await customerApi.exportCustomer(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const sendToQuickBooks = createAsyncThunk(
  SEND_TO_QUICK_BOOKS,
  async (customerId: string, { rejectWithValue }) => {
    try {
      const resp = await customerApi.sendToQuickBooks(customerId);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteCustomer = createAsyncThunk(
  DELETE_CUSTOMER,
  async (params: IBaseDeleteBody, { rejectWithValue }) => {
    try {
      const resp = await customerApi.deleteCustomer(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
